import { render, staticRenderFns } from "./TimeScreen.vue?vue&type=template&id=317e6dfb&scoped=true&"
import script from "./TimeScreen.vue?vue&type=script&lang=js&"
export * from "./TimeScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317e6dfb",
  null
  
)

export default component.exports